import React, { useEffect, useState, useContext } from "react";
import { useLocation } from "react-router-dom";
import { useNavigateParams } from "../../../hooks/useNavigateParams";

import { Context } from "../../../context/UserContext";
import FormComprovante from "./FormComprovante";
import styles from "../../form/Form.module.css";

/* hooks */
import useFlashMessage from "../../../hooks/useFlashMessage";

/* apis */
import * as LancamentosAPI from "../../../api/lancamentos";

const CreateOrEdit = () => {
    const [dados, setDados] = useState({});
    const [token] = useState(localStorage.getItem("token")) || "";
    const { parametro } = useContext(Context);
    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();
    const location = useLocation();
    const urlParams = new URLSearchParams(location.search);

    const pathname = "/RH";
    const ul = urlParams.get("ul");
    const li = urlParams.get("li");
    const tipo = urlParams.get("tipo");
    const operacaoUUID = urlParams.get("operacao");
    const uuid = urlParams.get("uuid");
    const btnText = urlParams.get("btnText");

    const params = new URLSearchParams({
        ul: ul,
        li: li,
        tipo: tipo,
        operacao: operacaoUUID,
        uuid: uuid,
        btnText: btnText,
        hasChanged: true,
    });

    useEffect(() => {
        if (!token) {
            navigate("/Auth", { replace: true });
        }
    }, [token, navigate]);

    useEffect(() => {
        if (uuid && uuid !== "null") {
            //consulta a API
            LancamentosAPI.listarComprovantes(uuid)
                .then((response) => {
                    setDados(response.data);
                })
                .catch((error) => {
                    console.error(error);
                    setFlashMessage(error.response.data.message, error.response.data.type);
                });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uuid]);

    async function managerLancamento(lancamento) {
        try {
            let response;

            response = await LancamentosAPI.cadastrar(lancamento);

            setFlashMessage(response.data.message, response.data.type);
            setTimeout(() => {
                if (response.data.type === "success") {
                    navigate(pathname, params);
                }
            }, parametro.msgTempo * 1000);
        } catch (error) {
            console.error(error);
            setFlashMessage(error.response.data.message, error.response.data.type);
        }
    }

    return (
        <section className={`${styles.form_container} ${styles[parametro.tema]}`}>
            <FormComprovante
                token={token}
                handleSubmit={managerLancamento}
                formData={dados}
                btnText={btnText}
                params={params}
                caminhoVoltar={pathname}
            />
        </section>
    );
};
export default CreateOrEdit;
